import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useNavigate, useLocation } from 'react-router-dom';
import StoreContext from "../app/store-context";
import { AuthState } from '../../../stores/auth-store';

const AuthStateObserver = ({ onAuthenticated, onUninitialized, onUnauthenticated, onUnverified }) => {
  const { authStore } = useContext(StoreContext);
  const navigate = useNavigate();
  const location = useLocation(); // Get current location

  useEffect(() => {
    console.log(`AuthStateObserver::useEffect authState changed to ${authStore.authState}`);
    switch (authStore.authState) {
      case AuthState.AUTHENTICATED:
        onAuthenticated && onAuthenticated(location, navigate);
        break;
      case AuthState.UNINITIALIZED:
        onUninitialized && onUninitialized(location, navigate);
        break;
      case AuthState.UNAUTHENTICATED:
        onUnauthenticated && onUnauthenticated(location, navigate);
        break;
      case AuthState.UNVERIFIED:
        onUnverified && onUnverified(location, navigate);
        break;
      default:
        console.warn('Unknown auth state:', authStore.authState);
    }
  }, [authStore.authState, navigate, location.pathname, onAuthenticated, onUninitialized, onUnauthenticated, onUnverified]);

  return null;
};

// Define prop types for the component
AuthStateObserver.propTypes = {
  onAuthenticated: PropTypes.func,
  onUninitialized: PropTypes.func,
  onUnauthenticated: PropTypes.func,
  onUnverified: PropTypes.func,
};

export default observer(AuthStateObserver);
